import { FeatureFlagStatus } from '@pflegenavi/shared/api';
import type { FeatureFlag } from '@pflegenavi/shared/api';
import { useFeatureFlagDev } from './useFeatureFlagDev';
import type { UseFeatureFlagBase } from './useFeatureFlagDev';

/**
 * Builds the platform's `useFeatureFlag`/`useFeatureFlagEnabled` pair around
 * the base hook that knows where the flags come from on that platform.
 *
 * @example
 * export const { useFeatureFlag } = createFeatureFlagHooks(useFeatureFlagBase);
 */
export const createFeatureFlagHooks = (
  useFeatureFlagBase: UseFeatureFlagBase
): {
  useFeatureFlag: (featureFlag: FeatureFlag) => FeatureFlagStatus;
  useFeatureFlagEnabled: (featureFlag: FeatureFlag) => boolean;
} => {
  // useFeatureFlagDev will return the dev feature flag if it is set. Since the user
  // can only set the dev feature flag if they have the DevTools enabled, we can
  // safely return the dev feature flag here.
  const useFeatureFlag = (featureFlag: FeatureFlag): FeatureFlagStatus =>
    useFeatureFlagDev(featureFlag, useFeatureFlagBase);

  const useFeatureFlagEnabled = (featureFlag: FeatureFlag): boolean =>
    useFeatureFlag(featureFlag) === FeatureFlagStatus.Enabled;

  return { useFeatureFlag, useFeatureFlagEnabled };
};
